export interface Faq {
  question: string
  answer: string
}
export const faqs: Faq[] = [
  {
    question: 'Co dokładnie zawiera pakiet?',
    answer:
      'Plan semestru na 16 tygodni w 3 ścieżkach poziomów, 50 gotowych ćwiczeń jazzowych, pełną część teoretyczną oraz 5 darmowych bonusów.',
  },
  {
    question: 'Jak działa plan semestru?',
    answer:
      'Jest podzielony na 16 tygodni. Każdy tydzień pokazuje temat do przerobienia, ćwiczenie do wydrukowania dla każdego poziomu, stronę z teorią do wyjaśnienia i zadanie domowe. Tydzień 1 to Twoja pierwsza lekcja.',
  },
  {
    question: 'Mam uczniów na bardzo różnych poziomach. Czy to zadziała?',
    answer:
      'Tak. Plan ma 3 ścieżki (początkujący, średniozaawansowany, wyzwanie), które co tydzień przerabiają ten sam temat, każda na swoim poziomie.',
  },
  {
    question: 'Czy muszę być specjalistą od jazzu?',
    answer:
      'Nie. Każda lekcja mówi Ci, co wyjaśnić i w jakiej kolejności, a teoria jest rozpisana w części teoretycznej. Materiał sprawdzi się także, jeśli na co dzień uczysz gitary rockowej, popowej lub klasycznej.',
  },
  {
    question: 'W jakim formacie są materiały?',
    answer:
      'Wszystko jest w formacie PDF — na razie bez filmów. Możesz drukować dowolne strony albo korzystać z nich na komputerze, tablecie lub telefonie.',
  },
  {
    question: 'Jak i kiedy otrzymam dostęp?',
    answer:
      'Zaraz po płatności wysyłamy na Twój e-mail link do pobrania wszystkich plików. Zwykle trwa to kilka minut — sprawdź też folder Spam lub Oferty. Pliki zostają u Ciebie na zawsze.',
  },
  {
    question: 'Czego potrzebuję, żeby korzystać z materiałów?',
    answer:
      'Wystarczy urządzenie, które otwiera pliki PDF. Drukarka przyda się, jeśli chcesz rozdawać ćwiczenia uczniom na papierze.',
  },
  {
    question: 'Jak mogę zapłacić?',
    answer:
      'Kartą, Google Pay lub Apple Pay. Płatność jest jednorazowa, w USD — Twój bank automatycznie przeliczy kwotę na złote. Bez subskrypcji.',
  },
  {
    question: 'Co jeśli materiały nie będą dla mnie?',
    answer:
      'Masz 10 dni gwarancji. Napisz na support@stockdigital.shop w ciągu 10 dni od zakupu, a zwrócimy całe $35. Nie musisz niczego tłumaczyć, a pobrane pliki zostają u Ciebie.',
  },
]
